import loadable from '@loadable/component'
import {createOverlayType} from '../../../contexts/overlay-manager'

const LeapDrawerLoadable = loadable(() => import('./internal'))

export const {
    useOverlay: useLeapDrawer,
    useIsOpen: useIsLeapDrawerOpen,
    preload: preloadLeapDrawer
} = createOverlayType(LeapDrawerLoadable)
